module.exports = __webpack_public_path__ + "static/img/consumable-raw-material.5cbdbe0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/consumable-raw-material.svg
// module id = 1006
// module chunks = 38